import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'jiraIssueMoveListMessageText'
	| 'jiraIssueMoveButtonLabelText'
	| 'jiraIssueMoveButtonErrorMessageText'
	| 'jiraIssueMoveSprintSelectorText'
	| 'jiraIssueMoveListTitleText'
	| 'jiraIssueMoveActionCardTitle';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		jiraIssueMoveListMessageText: {
			id: 'jira-issue-move.list-message-text',
			defaultMessage: 'Select the work items you want to move to a sprint:',
			description:
				'Instruction text displayed above the work item list in the Jira work item move to sprint action card within the AI conversation interface. Shown as instructional text in the action card body. The purpose is to guide users to select which work items they want to move to a sprint, explaining what action they need to take.',
		},
		jiraIssueMoveButtonLabelText: {
			id: 'jira-issue-move.button.move-label-text',
			defaultMessage: 'Move selected work items to sprint',
			description:
				'Button label displayed on the primary action button in the Jira work item move to sprint action card within the AI conversation interface. Shown as the text on a button at the bottom of the action card. When clicked, it moves all selected work items to the chosen sprint. The purpose is to provide a clear call-to-action for users to confirm and execute moving the selected work items to a sprint.',
		},
		jiraIssueMoveButtonErrorMessageText: {
			id: 'jira-issue-move.button.error-message-text',
			defaultMessage: 'Select at least one work item and one sprint to move',
			description:
				'Error message displayed in the Jira work item move to sprint action card within the AI conversation interface when a user attempts to move work items without selecting both at least one work item and one sprint. Shown as an error message or validation text. The purpose is to inform the user that they must select both work items and a target sprint before they can proceed with the move action.',
		},
		jiraIssueMoveSprintSelectorText: {
			id: 'jira-issue-move.sprint-selector.message-text',
			defaultMessage: 'Select the sprint you want to move these work items into:',
			description:
				'Instruction text displayed above the sprint selector dropdown in the Jira work item move to sprint action card within the AI conversation interface. Shown as instructional text above the selector. The purpose is to guide users to select which sprint they want to move the selected work items to, explaining what action they need to take.',
		},
		jiraIssueMoveListTitleText: {
			id: 'jira-issue-move.list-title-text',
			defaultMessage: 'Select all',
			description:
				'Title text displayed above a checkbox or selection control in the Jira work item move to sprint action card within the AI conversation interface. Shown as a section title or label. The purpose is to identify the "select all" control, which allows users to quickly select or deselect all work items in the list at once for bulk sprint movement.',
		},
		jiraIssueMoveActionCardTitle: {
			id: 'jira-issue-move.action-card-title',
			defaultMessage: 'Move work items',
			description:
				'Title text displayed at the top of an action card in the AI conversation interface when the AI suggests moving Jira work items to a sprint. Shown as the card header title. The purpose is to immediately communicate to the user what action the card represents, which is moving work items to a different sprint.',
		},
	});

export default message;
